export class NodePreviewHtmlCode {
  constructor(public codex_generation: PreviewApp.PreviewContentType, public notUseAnimation: boolean) {}
}
export class NodePreviewHtml {
  constructor(public code: NodePreviewHtmlCode[]) {}
}
